import React, { useEffect, useLayoutEffect, useState } from "react";
// import "./App.css";
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  Routes,
  Navigate,
} from "react-router-dom";
// import RedemptionForm from "./components/RedemptionForm";
// import UserformSurvey from "./components/UserformSurvey";
// import UserForm from "./components/UserForm";
// import Thankyou from "./components/Thankyou";
// import Index from "./components/Index";
// import CertDetails from "./components/CertDetails";
import NoInternet from "./components/NoInternet";
import RegisterForm from "./components/RegisterForm";
import TestOurTech_thankyou from "./components/TestOurTech_thankyou";
import Index from "./components/Index";
import UnderContruction from "./components/UnderContruction";
import UserformService from "./services/userform.service";
import { Helmet } from "react-helmet";
function App() {
  useEffect(() => {
    localStorage.setItem("isVoucher", false);
  }, []);

  // checking of redeemption and register
  const [permissions, setPermissions] = useState(null);
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  const LoadingBox = () => {
    return (
      <>
        <div className={`loader in bg-white`}>
          <div className="spinner-border main-spin"></div>
        </div>
      </>
    );
  };
  // const BackUpPage = () => {
  //   return (
  //     <div class="forbidden">
  //       <Helmet>
  //         <title>403 - ACCESS DENIED</title>
  //       </Helmet>
  //       <div class="lock"></div>
  //       <div class="message">
  //         <h1>Access to this page is restricted</h1>
  //         <p>You do not have the permissions to access this page.</p>
  //       </div>
  //     </div>
  //   );
  // };

  useLayoutEffect(() => {
    const getSiteDetailsPer = async () => {
      try {
        setPermissionsLoading(true);
        const response = await UserformService.getSitePermissions();

        setPermissions(response?.data?.response || null);
        setPermissionsLoading(false);
      } catch (error) {
        setPermissions(null);
        setPermissionsLoading(false);
      }
    };
    getSiteDetailsPer();
  }, []);
  // checking of redeemption and register end

  if (process.env.REACT_APP_STAGE === "PROD")
    console.log = function no_console() {};
  return (
    <NoInternet>
      <Routes>
        {/* 
       ! This URL's Not Uncomments
       */}
        {/* <Route path="/" element={<RedemptionForm />} /> */}
        {/* <Route path="/survey-form" element={<UserformSurvey />} /> */}
        {/* <Route path="/user-form" element={<UserForm />} /> */}
        {/* <Route path="/redemption-thankyou" element={<Thankyou />} /> */}
        {/* <Route path="/certificate-details" element={<CertDetails />} /> */}
        {/* <Route path="/" element={<Index />} /> */}

        <Route
          path="/"
          element={
            permissionsLoading ? (
              <LoadingBox />
            ) : permissions?.register === "yes" ? (
              <RegisterForm />
            ) : (
              <UnderContruction />
            )
          }
        />
        <Route
          path="/register/registration-thankyou"
          element={
            permissionsLoading ? (
              <LoadingBox />
            ) : permissions?.register === "yes" ? (
              <TestOurTech_thankyou />
            ) : (
              <UnderContruction />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" />} />

        {/* <Route path="/" element={<UnderContruction />} /> */}
      </Routes>
    </NoInternet>
  );
}

export default App;
